import WithRouter from 'custom/withRouter';
import React from 'react';
import Button from 'screens/components/basic/Button';
import { getDollarFormat } from 'utils/helpers';
import EditIcon from '@mui/icons-material/Edit';


const Header = (p) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(p.lastShift);
    return (
        <div className="text-center col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {/* Employee Container Info and Menu */}
            <div className="profile-view-lis text-left view-details-data">
                <div>
                    <h1 className="view-title mb-0 primary-color-text">{p.fullName}</h1>
                    <h4 className="view-subtitle mb-0 mt-0 primary-color-text">{p.role}</h4>
                    <h5 className="view-label mb-0 mt-0 pt-5px primary-color-text">ID: {p.id}</h5>
                </div>
                <div className="pt-2">
                    <div className='row' >
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 col-12 p-0">
                            <label>Total Sales:</label>
                            <p className="view-data green-text">{getDollarFormat(p.totalSales)}</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 col-12 p-0">
                            <label>Completed Orders:</label>
                            <p className="view-data primary-color-text">{p.completedOrders}</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 col-12 p-0">
                            <label>Last Shift:</label>
                            <p className="view-data primary-color-text">
                                {p.lastShift !== "" ?

                                    `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`

                                    : "No shifts"
                                }</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 col-12 p-0">
                            <label>Pin:</label>
                            <p className="view-data primary-color-text">{p.pin}</p>
                        </div>
                    </div>

                </div>
            </div>
            <div className={'view-btn-edit'}>
                {
                    p.canUpdateEmployee &&
                    <Button
                        newClass="view-edit-btn icon_text_btn"
                        className="glyphicon glyphicon-pencil"
                        type="IconRemove"
                        label="Edit"
                        name="Edit"
                        icon={<EditIcon sx={{ color: 'white' }} />}
                        onTouchTap={() => p.navigate(`/employee/edit/${p.id}`)}
                    />
                }
            </div>
        </div>
    )
}

export default WithRouter(Header);
